import { isSet } from "../utils/isSet";
import EmblaCarousel from 'embla-carousel';
import { addPrevNextBtnsClickHandlers } from './emblaCarouselControls';

function initEmblaCarousels(){
    function initHireGalleryCarousel(){
        const hireGalleryCarouselNodes = document.querySelectorAll('.section--hire-detail .embla');
        if(!isSet(hireGalleryCarouselNodes)) return;

        hireGalleryCarouselNodes.forEach((hireGalleryCarouselNode) => {
            const hireGalleryViewportNode = hireGalleryCarouselNode.querySelector('.embla__viewport');
            if(!isSet(hireGalleryViewportNode)) return;
    
            const hireGalleryOptions = {
                align: 'start',
                dragFree: false,
                loop: true
            }
    
            const hireGalleryPrevBtnNode = hireGalleryCarouselNode.querySelector('.embla__button--prev');
            const hireGalleryNextBtnNode = hireGalleryCarouselNode.querySelector('.embla__button--next');
    
            const hireGalleryEmblaApi = EmblaCarousel(
                hireGalleryViewportNode, 
                hireGalleryOptions
            );
    
            if(isSet(hireGalleryPrevBtnNode) && isSet(hireGalleryNextBtnNode)){
                const removeHireGalleryPrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    hireGalleryEmblaApi,
                    hireGalleryPrevBtnNode,
                    hireGalleryNextBtnNode
                );
    
                hireGalleryEmblaApi.on('destroy', removeHireGalleryPrevNextClickHandlers);
            }
        });
    }
    initHireGalleryCarousel();



    function initTrainingGalleryCarousel(){
        const trainingGalleryCarouselNodes = document.querySelectorAll('.section--training-detail .embla');
        if(!isSet(trainingGalleryCarouselNodes)) return;

        trainingGalleryCarouselNodes.forEach((trainingGalleryCarouselNode) => {
            const trainingGalleryViewportNode = trainingGalleryCarouselNode.querySelector('.embla__viewport');
            if(!isSet(trainingGalleryViewportNode)) return;
    
            const trainingGalleryOptions = {
                align: 'start',
                dragFree: false,
                loop: true
            }
    
            const trainingGalleryPrevBtnNode = trainingGalleryCarouselNode.querySelector('.embla__button--prev');
            const trainingGalleryNextBtnNode = trainingGalleryCarouselNode.querySelector('.embla__button--next');
    
            const trainingGalleryEmblaApi = EmblaCarousel(
                trainingGalleryViewportNode, 
                trainingGalleryOptions
            );
    
            if(isSet(trainingGalleryPrevBtnNode) && isSet(trainingGalleryNextBtnNode)){
                const removeTrainingGalleryPrevNextClickHandlers = addPrevNextBtnsClickHandlers(
                    trainingGalleryEmblaApi,
                    trainingGalleryPrevBtnNode,
                    trainingGalleryNextBtnNode
                );
    
                trainingGalleryEmblaApi.on('destroy', removeTrainingGalleryPrevNextClickHandlers);
            }
        });
    }
    initTrainingGalleryCarousel();
}

exports.initEmblaCarousels = initEmblaCarousels